import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrinityService } from 'app/services/trinity/trinity.service';

@Injectable({
  providedIn: 'root',
})
export class LikeService {
  private readonly endpoint: string = '/like';
  constructor(private trinityService: TrinityService) {}

  like(file_id: string): Observable<void> {
    const res = this.trinityService.post<void>(`${this.endpoint}/${file_id}`, {
      authorized: true,
    });

    return res;
  }

  unlike(file_id: string): Observable<void> {
    const res = this.trinityService.delete<void>(
      `${this.endpoint}/${file_id}`,
      {
        authorized: true,
      },
    );

    return res;
  }
}
